<template>
  <section class="ev-column-wise-masonry">
    <div
      class="ev-column-wise-masonry__column"
      v-for="(column, index) in nodeColumns"
      :key="`ev-column-wise-masonry-column-${index}`"
      :style="columnStyles"
    >
      <div v-for="(node, index) in column" :key="`ev-column-wise-masonry-node-${index}`">
        <slot v-bind:node="node" v-bind:index="index" />
      </div>
    </div>
    <div class="ev-column-wise-masonry__empty-state" v-if="!nodes.length">
      <slot name="empty" />
    </div>
  </section>
</template>

<script>
import { ColumnWiseLayout, getBreakpointsColumnCount } from "./helpers";

export default {
  name: "ColumnWiseMasonryLayout",
  props: {
    nodes: {
      type: Array,
      required: true
    },
    totalCount: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      windowWidth: 0
    };
  },
  mounted() {
    window.addEventListener("resize", this._handleWindowSize);
    this._handleWindowSize();
  },
  computed: {
    /** Calculated columns count depending on window width */
    columnsCount() {
      return getBreakpointsColumnCount(this.windowWidth);
    },
    grid() {
      return new ColumnWiseLayout(this.totalCount, this.columnsCount);
    },
    /** Create column arrays */
    nodeColumns() {
      let columns = [];

      [...this.nodes].forEach((node, index) => {
        const gridPosition = this.grid.getPositionByIndex(this.totalCount - 1 - index);
        const colIndex = gridPosition.col - 1;
        if (!columns[colIndex]) columns[colIndex] = [];

        // Note: no need for row position at the moment
        // as all posts always sorted by date
        columns[colIndex].push(node);
      });

      return columns;
    },
    /** Layout column styles */
    columnStyles() {
      return {
        width: `${100 / this.columnsCount}%`
      };
    }
  },
  methods: {
    /** Handle window width for vue reactivity */
    _handleWindowSize() {
      this.windowWidth = window.innerWidth;
    }
  }
};
</script>

<style>
.ev-column-wise-masonry {
  display: flex;
  margin-left: -10px;
}

.ev-column-wise-masonry .ev-column-wise-masonry__column {
  border-left: 10px solid transparent;
  box-sizing: border-box;
}

.ev-column-wise-masonry .ev-column-wise-masonry__node {
  /**/
}

.ev-column-wise-masonry .ev-column-wise-masonry__empty-state {
  width: 100%;
}
</style>
